window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (timeOutFn) {
  return setTimeout(timeOutFn, 1000 / 60);
};

window['CP_IT_Sitewide_03_shopify'] = function () {
  if (document.querySelector('#menu-drawer') && !document.querySelector('.CP_IT_Sitewide_03_shopify') && window.innerWidth < 768) {
    document.body.classList.add('CP_IT_Sitewide_03_shopify');

    const style = document.createElement("style");
    style.textContent = `
    .menu-drawer {
      width: 85% !important;
  }
    .menu-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
      padding: 10px 20px;
    }
    
      .menu-img-tile {
      position: relative;
      border-radius: 10px;
      overflow: hidden;
      text-decoration: none;
      width: 100%;
      aspect-ratio: 1/1;
      display: block;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      align-items: flex-end !important;
      display: flex !important;
      justify-content: center !important;
    }
      .menu-tile img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
      background: #fff;
    }
    
       .menu-img-tile.full {
      grid-column: span 2;
      aspect-ratio: 2/1;
    }
    
      .menu-img-tile.tile-no-overlay .tile-overlay {
      display: none;
    }
    
    
      .tile-label {
      width: 100%;
      padding: 6px 4px;
      font-size: 13px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      display: block;
    }
    
      .tws-l1-panel .small-menu {
      display: block !important;
    }
    
      .tws-l1-panel .small-menu a.tws-l1.solo {
      display: flex !important;
      align-items: center;
      padding: 12px 10px;
      gap: 10px;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
      color: #000;
    }
    
      .menu-img-tile.full.tile-no-overlay {
      background-size: contain;
      height: auto;
      aspect-ratio: 1 / 0.28;
      padding: 0px;
      margin: 0px;
  }
  
    .menu-img-tile.full  {
      grid-column: span 2;
      aspect-ratio: 2 / 0.6;
  
  }
    .tws-l1-panel .small-menu a.tws-l1.solo img {
      width: 25px;
      height: 25px;
      object-fit: contain;
    }
    
  
  
  
    /* review css  */
  
  
      .review-section {
      padding: 0 15px;
      font-family: Arial, sans-serif;
      position: relative;
      max-width: 420px;
      margin: 0 auto;
    }
    
      .review-wrapper {
      overflow: hidden;
    }
    
      .review-container {
      display: flex;
      transition: transform 0.5s ease-in-out;
    }
    
      .review-card {
      flex: 0 0 100%;
      min-width: 100%;
      box-sizing: border-box;
      border: 1px solid #F3C96B;
      border-radius: 8px;
      padding: 16px;
      background: #fff;
    }
    
      .review-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 10px;
    }
    
      .review-left {
      display: flex;
      align-items: center;
    }
    
      .review-initials {
      background: #2E5A3A;
      color: #fff;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      font-weight: bold;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      flex-shrink: 0;
    }
    
      .review-meta {
      display: flex;
      flex-direction: column;
      gap: 0;
    }
    
      .review-name {
      line-height: 1.2;
      color: #363636;
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
  }
    
    .review-date {
      font-size: 12px;
      color: #555;
    }
    
      .review-stars {
      color: #00B67A;
      font-size: 16px;
      white-space: nowrap;
      transform: translateY(-5px);
  }
    .review-stars-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end; 
    }
      .review-text {
      color: #363636;
      line-height: 1.5;
      font-family: Montserrat;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      align-items: center;
  }
    
    .pagination-dots {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 24px;
    }
    
      .review-dot {
      width: 30px !important;
      height: 5px !important;
      background-color: #C5C4C2 !important;
      border-radius: 6px !important;
      margin: 0 4px !important;
      display: inline-block !important;
      opacity: 1 !important;
      visibility: visible !important;
      font-size: 0 !important;
      line-height: 0 !important;
      overflow: hidden !important;
    }
      .review-dot.active {
      background-color: #4B6246 !important;
      width: 30px !important;
      border-radius: 6px !important;
    }
    
    
  /* Header css */
  
    #Details-menu-drawer-container[open] ~ .header {
      display: none !important;
    }
    
      #menu-drawer {
      position: fixed !important;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100vw;
      max-width: 100%;
      background: white;
      z-index: 9999 !important;
      overflow-y: auto;
    }
  
      .drawer-header-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      border-bottom: 1px solid #ddd;
      background: #fff;
    }
    
      .logonew {
      width: 72px !important;
      height: 37.8px !important;
    }
    
      .drawer-close-btn {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
    
      .drawer-close-btn svg {
      width: 24px;
      height: 24px;
      color: #000;
    }
    `;
    document.head.appendChild(style);


    (() => {
      const imgSrc = {
        'NEW!': 'https://cdn.shopify.com/s/files/1/0155/8131/files/Group_11283.png?v=1746770952',
        'WOMEN': 'https://cdn.shopify.com/s/files/1/0155/8131/files/Mask_group_2.png?v=1746774590',
        'MEN': 'https://cdn.shopify.com/s/files/1/0155/8131/files/Mask_group_3.png?v=1746774589',
        'FABRICS': 'https://cdn.shopify.com/s/files/1/0155/8131/files/image_3.png?v=1746774589',
        'HOME & DECOR': 'https://cdn.shopify.com/s/files/1/0155/8131/files/image_4_1.png?v=1746774589',
        'JEWELLERY & ACCESSORIES': 'https://cdn.shopify.com/s/files/1/0155/8131/files/image_5_2.png?v=1746774589',
        'BAGS & STATIONERY': 'https://cdn.shopify.com/s/files/1/0155/8131/files/Mask_group_4.png?v=1746774589',
        'CRAFTS OF INDIA': 'https://cdn.shopify.com/s/files/1/0155/8131/files/Mask_group_1.png?v=1746770952'
      };

      const iconMap = {
        'WHOLESALE QUERIES': 'https://cdn.shopify.com/s/files/1/0155/8131/files/wholesaler_1.png?v=1746774587',
        'GIFTING': 'https://cdn.shopify.com/s/files/1/0155/8131/files/gift.png?v=1746774589',
        'OCCASIONS & FESTIVALS': 'https://cdn.shopify.com/s/files/1/0155/8131/files/party-ornament.png?v=1746774588',
        'BLOGS': 'https://cdn.shopify.com/s/files/1/0155/8131/files/article.png?v=1746774589',
        'FAQs': 'https://cdn.shopify.com/s/files/1/0155/8131/files/question.png?v=1746774588',
        'CONTACT US': 'https://cdn.shopify.com/s/files/1/0155/8131/files/contact-mail_1.png?v=1746774589'
      };

      const root = document.querySelector('.tws-l1-panel');
      if (!root) return console.warn('Missing .tws-l1-panel');

      const tiles = Array.from(root.querySelectorAll(':scope > .tws-l1, :scope > a.tws-l1.solo'));
      const grid = document.createElement('div');
      grid.className = 'menu-grid';

      const renderTile = (el, text) => {
        el.classList.add('menu-img-tile');
        el.style.backgroundImage = `url("${imgSrc[text]}")`;
        el.innerHTML = '';

        if (text === 'NEW!') {
          el.classList.add('full', 'tile-no-overlay');
        } else if (text === 'CRAFTS OF INDIA') {
          el.classList.add('full');
        }

        if (text !== 'NEW!') {
          const overlay = document.createElement('div');
          overlay.className = 'tile-overlay';
          overlay.innerHTML = `<span class="tile-label">${text}</span>`;
          el.appendChild(overlay);
        }

        return el;
      };

      const newItem = tiles.find(el => el.textContent.trim() === 'NEW!');
      if (newItem) grid.appendChild(renderTile(newItem, 'NEW!'));

      tiles.forEach(el => {
        const text = el.textContent.trim();
        if (text !== 'NEW!' && text !== 'CRAFTS OF INDIA' && imgSrc[text]) {
          grid.appendChild(renderTile(el, text));
        }
      });

      const lastItem = tiles.find(el => el.textContent.trim() === 'CRAFTS OF INDIA');
      if (lastItem) grid.appendChild(renderTile(lastItem, 'CRAFTS OF INDIA'));

      root.insertBefore(grid, root.firstChild);

      const smallMenu = root.querySelector('.small-menu');
      if (smallMenu) {
        const links = smallMenu.querySelectorAll('a.tws-l1.solo');
        links.forEach(link => {
          const label = link.textContent.trim();
          const icon = iconMap[label];
          if (icon) {
            const img = document.createElement('img');
            img.src = icon;
            img.alt = label;
            link.prepend(img);
          }
        });
      }
    })();




    //   review code


    (() => {
      const reviews = [
        {
          initials: "MB",
          name: "MONICA BOXLEY",
          date: "Apr 30, 2025",
          rating: 5,
          text: "Superb customer service. Great products and very efficient global delivery. Am v impressed."
        },
        {
          initials: "ST",
          name: "SOLANGE TUNGU",
          date: "Apr 26, 2025",
          rating: 5,
          text: "Very professional service. Loved the packaging and delivery too."
        },
        {
          initials: "AS",
          name: "ANTHONY SPANGLER",
          date: "Feb 21, 2025",
          rating: 5,
          text: "Wonderful selection, carefully made, packaged and delivered in an extremely timely manner."
        },
        {
          initials: "NA",
          name: "NEEHARIKA A",
          date: "Jan 3, 2025",
          rating: 5,
          text: "Firstly, I loved the Red-Bagh hand block printed handwoven cotton towel."
        }
      ];

      const root = document.querySelector(".tws-l1-panel");
      const smallMenu = root?.querySelector(".small-menu");
      if (!root || !smallMenu) return;

      const section = document.createElement("div");
      section.className = "review-section";

      const cardsHTML = reviews.map(r => `
      <div class="review-card">
        <div class="review-header">
          <div class="review-left">
            <div class="review-initials">${r.initials}</div>
            <div class="review-meta">
              <div class="review-name">${r.name}</div>
              <div class="review-date">${r.date}</div>
            </div>
          </div>
          <div class="review-stars-wrapper">
          <div class="review-stars">★★★★★</div>
          </div>
        </div>
        <div class="review-text">${r.text}</div>
      </div>
    `).join("");

      section.innerHTML = `
      <div class="review-wrapper">
        <div class="review-container">${cardsHTML}</div>
      </div>
     <div class="pagination-dots">
  ${reviews.map((_, i) => `<div class="review-dot${i === 0 ? ' active' : ''}"></div>`).join("")}
</div>

    `;

      root.insertBefore(section, smallMenu);

      let current = 0;
      const container = section.querySelector(".review-container");
      const dots = section.querySelectorAll(".review-dot");

      const slide = index => {
        container.style.transform = `translateX(-${index * 100}%)`;
        dots.forEach((dot, i) => dot.classList.toggle("active", i === index));
        current = index;
      };

      dots.forEach((dot, i) => {
        dot.addEventListener("click", () => slide(i));
      });

      setInterval(() => {
        const next = (current + 1) % reviews.length;
        slide(next);
      }, 3000);
    })();



    //   Header 


    const details = document.getElementById('Details-menu-drawer-container');
    const summary = details?.querySelector('summary.header__icon--menu');
    const drawer = document.getElementById('menu-drawer');

    const oldHeader = drawer.querySelector('.drawer-header-wrapper');
    if (oldHeader) oldHeader.remove();

    const headerHTML = `
  <div class="drawer-header-wrapper" style="display: flex; align-items: center; justify-content: space-between; padding: 10px 20px;">
    <img src="https://itokri.com/cdn/shop/files/Group_1458_2x_95f81960-e86c-4e73-a9e2-9b93370be915.png?v=1660109560&width=160" class="logonew" style="height: 30px;">
    <button class="drawer-close-btn" style="background: none; border: none; cursor: pointer;">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-close" fill="none" viewBox="0 0 18 17" width="24" height="24">
        <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
      </svg>
    </button>
  </div>
`;
    drawer.insertAdjacentHTML('afterbegin', headerHTML);

    function unlockScroll() {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden');
    }

    drawer.querySelector('.drawer-close-btn').addEventListener('click', () => {
      details.removeAttribute('open');
      const overlay = document.querySelector('.menu-drawer__overlay, .overlay, .drawer__overlay');
      if (overlay) overlay.style.display = 'none';
      if (summary) summary.setAttribute('aria-expanded', 'false');

      unlockScroll();
    });

    const overlay = document.querySelector('.menu-drawer__overlay, .overlay, .drawer__overlay');
    if (overlay) {
      overlay.style.display = 'block';
      overlay.onclick = () => {
        details.removeAttribute('open');
        overlay.style.display = 'none';
        if (summary) summary.setAttribute('aria-expanded', 'false');

        unlockScroll();
      };
    }


  } else if (!document.querySelector('.CP_IT_Sitewide_03_shopify')) {
    window.requestAnimationFrame(window.CP_IT_Sitewide_03_shopify);
  }
};

window.CP_IT_Sitewide_03_shopify();
